import { SystemKeywordType } from 'apps/systemKeywords/SystemKeywordType'
import { ChannelType } from 'common/core/constants/ChannelType'
import { parseFlow } from 'common/flow/models/Flow/parseFlow'
import { SystemKeywordsApi } from 'shared/api/requests/systemKeywords'
import { createAsyncAction } from 'shared/lib/redux'

export const loadCurrentSystemKeywordsFlow = createAsyncAction(
  'systemKeywords/loadCurrentSystemKeywordsFlow',
  (
    { channel, systemKeywordType }: { channel: ChannelType; systemKeywordType: SystemKeywordType },
    { dispatch },
  ) => {
    if (!channel || !systemKeywordType) {
      return
    }

    if (systemKeywordType === SystemKeywordType.SUBSCRIBE) {
      dispatch(getSubscribeFlow(channel))
      return
    }

    if (systemKeywordType === SystemKeywordType.UNSUBSCRIBE) {
      dispatch(getUnsubscribeFlow(channel))
      return
    }
  },
)

export const getSubscribeFlow = createAsyncAction(
  'systemKeywords/getSubscribeFlow',
  async (channel: ChannelType) => {
    const response = await SystemKeywordsApi.getSubscribeFlow({ body: { channel } })
    return parseFlow(response.data.flow)
  },
)

export const getUnsubscribeFlow = createAsyncAction(
  'systemKeywords/getUnsubscribeFlow',
  async (channel: ChannelType) => {
    const response = await SystemKeywordsApi.getUnsubscribeFlow({ body: { channel } })
    return parseFlow(response.data.flow)
  },
)
